import React from 'react';
import { Box } from '@chakra-ui/react';

// There are two types of SectionAnchorProps - one with id and one without
type SectionAnchorProps = {
  id: string;
} | {
  id?: undefined;
};

/**
 * Creates an invisible anchor point that accounts for the fixed header
 * This should be placed at the beginning of each section
 */
const SectionAnchor: React.FC<SectionAnchorProps> = (props) => {
  // If id is undefined or empty, don't render anything
  if (!props.id) return null;

  return (
    <Box
      id={props.id}
      position="relative"
      top={{ base: "-90px", md: "-100px" }}
      visibility="hidden"
      height="0"
      width="0"
      aria-hidden="true"
    />
  );
};

export default SectionAnchor;